module.exports = __webpack_public_path__ + "static/media/fix_RSP.4a519d4a.png";